import { UserErrorCode } from '../helpers/ErrorCodes';
import { PasswordPolicyScope, PasswordPolicyService } from '../services/PasswordPolicyService';
import { ServerService } from '../services/ServerService';

export interface IInitializationFormModelScope {
  username: string;
  password: string;
  confirmPassword: string;
  displayName: string;
}

export interface IInitializationScope extends PasswordPolicyScope {
  maybeInitialize: () => void;
  isActiveDirectory: () => boolean;
  isLocal: () => boolean;
  passwordFieldsAreNonEmpty: () => boolean;
  initializationForm: ng.IFormController;
  formData: IInitializationFormModelScope;
  result: string;
  busy: boolean;
  errorMessageKey: string;
}

export class InitializationCtrl {

  public static $inject = [
    '$scope',
    '$state',
    'PasswordPolicyService',
    'ServerService'
  ];

  constructor(
    $scope: IInitializationScope,
    $state: ng.ui.IStateService,
    passwordPolicyService: PasswordPolicyService,
    server: ServerService
  ) {
    $scope.formData = {
      username: '',
      password: '',
      confirmPassword: '',
      displayName: ''
    };
    $scope.isActiveDirectory = () => server.isServerDomainFamilyActiveDirectory();
    $scope.isLocal = () => server.isServerDomainFamilyLocal();

    $scope.passwordFieldsAreNonEmpty = () => {
      return !$scope.isActiveDirectory() &&
        $scope.formData.password &&
        $scope.formData.confirmPassword &&
        $scope.formData.password.length > 0 &&
        $scope.formData.confirmPassword.length > 0;
    };

    const respectsPasswordValidation =
      passwordPolicyService.loadPoliciesIntoScope($scope, () => $scope.formData.password, () => {});

    $scope.maybeInitialize = () => {
      if ($scope.initializationForm.$valid && respectsPasswordValidation()) {
        $scope.busy = true;
        server.initialize($scope.formData.username, $scope.formData.password, $scope.formData.displayName)
          .then(() => {
            $scope.result = 'success';
            $state.go('main.site.content.site.projects', {siteUrlName: ''});
          })
          .catch((errorCode: number) => {
            $scope.result = 'failure';
            $scope.busy = false;
            switch(errorCode) {
              case UserErrorCode.UserInsufficientLicenses:
                $scope.errorMessageKey = 'signInFailedUnlicensedServer';
                break;
              case UserErrorCode.UserPasswordNotRespectingPolicies:
                $scope.errorMessageKey = 'errorUserPasswordNotRespectingPolicies';
                break;
              default:
                $scope.errorMessageKey = 'initializationFailed';
                break;
            }
          });
      } else {
        $scope.result = 'invalidForm';
      }
    };

  }

}
